// headerConfig.js - Statische Konfiguration für den Header
// Ausgelagert aus Header.jsx - keine Logik-Änderungen

import React from 'react';

// Event-Definitionen für Schnellwahl
export const QUICK_EVENTS = [
  { key: 'none', label: 'Standard', icon: '🌊' },
  { key: 'christmas', label: 'Weihnachten', icon: '🎄' },
  { key: 'winter', label: 'Winter', icon: '❄️' },
  { key: 'silvester', label: 'Silvester', icon: '🎆' },
  { key: 'newyear', label: 'Neujahr', icon: '🎊' },
  { key: 'easter', label: 'Ostern', icon: '🐰' },
  { key: 'summer', label: 'Sommer', icon: '☀️' },
  { key: 'blackweek', label: 'Black Week', icon: '💰' },
  { key: 'blackfriday', label: 'Black Friday', icon: '🛒' },
];

// ========== MENU BUTTON REGISTRY ==========
// Alle verfügbaren Menü-Buttons — Admin CMS wählt max. 4 aus
export const MENU_BUTTON_REGISTRY = {
  dashboard: {
    id: 'dashboard',
    label: 'Dashboard',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M3 13h8V3H3v10z" />
        <path d="M13 21h8V11h-8v10z" />
        <path d="M13 3h8v6h-8V3z" />
        <path d="M3 17h8v4H3v-4z" />
      </svg>
    ),
    type: 'section', // navigiert per onAppSectionChange
    section: 'dashboard',
  },
  tarife: {
    id: 'tarife',
    label: 'Tarife',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2" y="5" width="20" height="14" rx="3" />
        <path d="M2 10h20" />
        <circle cx="17" cy="15" r="2" />
      </svg>
    ),
    type: 'section',
    section: 'cards',
  },
  system: {
    id: 'system',
    label: 'System',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
    type: 'submenu', // öffnet System-Submenu
  },
  admin: {
    id: 'admin',
    label: 'Admin',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
        <path d="M18.7 8a2 2 0 0 0-1-1.73l-5-2.9a2 2 0 0 0-2 0l-5 2.9A2 2 0 0 0 4.3 8v5.9a2 2 0 0 0 1 1.74l5 2.9a2 2 0 0 0 2 0l5-2.9a2 2 0 0 0 1-1.74Z" />
      </svg>
    ),
    type: 'link',
    href: '/admin/index.html',
  },
  spielgeld: {
    id: 'spielgeld',
    label: 'Spielgeld',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="4" y="2" width="16" height="20" rx="2" />
        <line x1="8" y1="6" x2="16" y2="6" />
        <line x1="8" y1="10" x2="8" y2="10.01" />
        <line x1="12" y1="10" x2="12" y2="10.01" />
        <line x1="16" y1="10" x2="16" y2="10.01" />
        <line x1="8" y1="14" x2="8" y2="14.01" />
        <line x1="12" y1="14" x2="12" y2="14.01" />
        <line x1="16" y1="14" x2="16" y2="14.01" />
        <line x1="8" y1="18" x2="16" y2="18" />
      </svg>
    ),
    type: 'section',
    section: 'spielgeld',
  },
  druck: {
    id: 'druck',
    label: 'Druck',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M6 9V2h12v7" />
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
        <rect x="6" y="14" width="12" height="8" />
      </svg>
    ),
    type: 'link',
    href: '/pages/druckansicht.html',
  },
  bruttonetto: {
    id: 'bruttonetto',
    label: 'Brutto/Netto',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 6v12M8 9.5C8 8.12 9.79 7 12 7s4 1.12 4 2.5c0 2.5-4 2.5-4 5C12 15.88 13.79 17 12 17"/>
        <line x1="9" y1="18" x2="15" y2="18"/>
      </svg>
    ),
    type: 'section',
    section: 'bruttonetto',
  },
  smartphones: {
    id: 'smartphones',
    label: 'Smartphones',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="5" y="2" width="14" height="20" rx="2"/>
        <line x1="12" y1="18" x2="12.01" y2="18"/>
      </svg>
    ),
    type: 'section',
    section: 'smartphones',
  },
  router: {
    id: 'router',
    label: 'Router',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2" y="14" width="20" height="6" rx="2"/>
        <path d="M6 14V9a6 6 0 0 1 12 0v5"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    ),
    type: 'section',
    section: 'router',
  },
  konfigurator: {
    id: 'konfigurator',
    label: 'Konfigurator',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
    type: 'section',
    section: 'konfigurator',
  },
  flyer: {
    id: 'flyer',
    label: 'Flyer',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
    type: 'section',
    section: 'flyer',
  },
  abschluss: {
    id: 'abschluss',
    label: 'Abschluss',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    ),
    type: 'section',
    section: 'abschluss',
  },
  design: {
    id: 'design',
    label: 'Design',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="13.5" cy="6.5" r=".5"/>
        <circle cx="17.5" cy="10.5" r=".5"/>
        <circle cx="8.5" cy="7.5" r=".5"/>
        <circle cx="6.5" cy="12.5" r=".5"/>
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
      </svg>
    ),
    type: 'section',
    section: 'design',
  },
  wkz: {
    id: 'wkz',
    label: 'WKZ',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
    type: 'section',
    section: 'wkz',
  },
  logout: {
    id: 'logout',
    label: 'Abmelden',
    icon: (
      <svg className="hero-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
    ),
    type: 'action',
    action: async () => {
      try {
        await fetch('/api/auth/logout', { method: 'POST' });
      } catch (e) {
        console.error('Logout error:', e);
      } finally {
        localStorage.removeItem('tef_jwt');
        localStorage.removeItem('tef_user');
        localStorage.removeItem('tef_role');
        window.location.href = '/login';
      }
    }
  }
};

export const DEFAULT_MENU_BUTTONS = ['dashboard', 'tarife', 'admin', 'druck'];
